import { isTerminal } from '../../../taskModel';
import { timeAgo } from '../taskTimeAgo.utils';
const SEPARATOR = ' · ';
export function bulkSendTitle(task, texts) {
    return task.jobName ? texts.titleNamed({
        name: task.jobName
    }) : texts.title();
}
export function bulkSendSubtitle(task, texts) {
    if (!isTerminal(task.status)) return texts.progressSubtitle({
        sent: task.succeeded,
        total: task.total
    });
    if (task.status === 'cancelled') return texts.cancelledSubtitle({
        sent: task.succeeded,
        total: task.total
    });
    if (task.status === 'failed') return [
        texts.failedRun(),
        timeAgo(task.updatedAt)
    ].join(SEPARATOR);
    return [
        texts.sentCount({
            sent: task.succeeded
        }),
        task.jobName,
        timeAgo(task.updatedAt)
    ].filter((part)=>part != null).join(SEPARATOR);
}
